<nz-modal
  [(nzVisible)]="isVisible"
  nzCentered
  [nzFooter]="null"
  nzClosable="true"
  nzWidth="800px"
  nzCloseIcon="null"
  (nzAfterClose)="onModalClose()"
>
  <ng-container *nzModalContent>
    <div class="flex items-center gap-2">
      <img
        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/lock-1.svg"
        alt="lock"
      />
      <span class="text-xl font-medium">Secret Key Generated</span>
    </div>
    <hr />
    <div
      class="w-full rounded-lg border-2 border-[#FBA63C] bg-[#FFF8E1] p-3 flex items-start gap-2"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg"
        alt="warning"
      />
      <div class="flex flex-col items-start gap-2">
        <span class="font-semibold text-base">Important Information</span>
        <span class="text-sm"
          >This secret key is shown only once. Make sure to copy and store it
          securely.</span
        >
      </div>
    </div>

    <div class="flex flex-col gap-2 mt-4 w-full">
      <div class="flex flex-col gap-2">
        <span>User ID:</span>
        <nz-input-group [nzSuffix]="suffixTemplate" class="w-full">
          <input
            type="text"
            nz-input
            placeholder="User ID"
            [ngModel]="userId()"
            readonly
            class="rounded-lg h-9 border-gray-300 cursor-default"
            (click)="copyToClipboard(userId())"
          />
          <ng-template #suffixTemplate>
            <i class="icon-copy text-gray-400 cursor-pointer" (click)="copyToClipboard(userId())"></i>
          </ng-template>
        </nz-input-group>
      </div>
      <div class="flex flex-col gap-2">
        <span>Secret Key:</span>
        <nz-input-group [nzSuffix]="suffixSecretKeyTemplate" class="w-full">
          <input
            type="text"
            nz-input
            placeholder="Secret Key"
            [ngModel]="secretKey()"
            readonly
            class="rounded-lg h-9 border-gray-300 cursor-default"
            (click)="copyToClipboard(secretKey())"
          />
          <ng-template #suffixSecretKeyTemplate>
            <i class="icon-copy text-gray-400 cursor-pointer" (click)="copyToClipboard(secretKey())"></i>
          </ng-template>
        </nz-input-group>
      </div>
      <span class="text-sm text-gray-500">Click the license key or press Copy to copy it to your clipboard.</span>
    </div>

    <div
      *ngIf="isVisibleInfo"
      class="w-full mt-4 rounded-lg border-2 border-[#08A0F7] bg-[#DFF3FF] p-3 flex items-start gap-2"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/info-circle-fill-blue.svg"
        alt="warning"
      />
      <div class="flex flex-col items-start gap-2">
        <span class="font-semibold text-base">How to use in the APK Listener App:</span>
        <ul class="list-disc pl-5">
          <li>Open the <span class="font-semibold">APK Listener</span> app on your Android device.</li>
          <li>Copy and paste the <span class="font-semibold">User ID</span> into the User ID field in the app.</li>
          <li>Copy and paste the <span class="font-semibold">Secret Key</span> into the Secret Key field in the app.</li>
          <li>Make sure the <span class="font-semibold">Webhook URL</span> in the app matches the one shown on the Admin Webhook Configuration page.</li>
          <li>Save the configuration, then perform a test transaction to verify the notification.</li>
        </ul>
        <span>Note: The secret key will not be displayed again after this modal is closed. If you need a new key, delete the existing configuration and create a new one on the Admin page.</span>
      </div>
      <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/close.svg" alt="warning" class="cursor-pointer w-10 h-10 opacity-50" (click)="isVisibleInfo = !isVisibleInfo">
    </div>

    <div class="flex items-center justify-between gap-2 mt-4">
      <div class="flex items-center gap-2">
        <label nz-checkbox [(ngModel)]="isSaved">
          <span>I have securely saved the secret key.</span>
        </label>
      </div>
      <button nz-button [nzType]="isSaved ? 'primary' : 'default'" (click)="onModalClose()" [disabled]="!isSaved">Close</button>
    </div>
  </ng-container>
</nz-modal>
